// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class QuickLookService {
   configService: ConfigService
   quickLookConfig: any

   constructor(configService: any) {
      this.showCallNums = this.showCallNums.bind(this)
      this.showDeweys = this.showDeweys.bind(this)
      this.syndeticsClient = this.syndeticsClient.bind(this)
      this.showSyndeticsContent = this.showSyndeticsContent.bind(this)
      this.showPublicNotes = this.showPublicNotes.bind(this)
      this.displayLibraryNotes = this.displayLibraryNotes.bind(this)
      this.configService = configService
      this.quickLookConfig = this.configService.data.quickLook
   }

   showCallNums() {
      return this.quickLookConfig.showCallNums
   }

   showDeweys() {
      return this.quickLookConfig.showDeweys
   }

   syndeticsClient() {
      return this.quickLookConfig.syndeticsClient
   }

   displayLibraryNotes() {
      return this.quickLookConfig.displayLibraryNotes
   }

   showSyndeticsContent(doc: any) {
      return this.quickLookConfig.enableSyndeticsPlus && doc.isbns && doc.isbns.length
   }

   showPublicNotes(doc: any) {
      return (this.quickLookConfig.showPublicNotes || this.quickLookConfig.showLocationNotes) &&
      (doc.iedl_dbids?.length > 0)
   }

   setDatabases(doc: any) {
      // 'Source' field logic
      const documents = _.compact([doc].concat(doc.peer_documents))
      const docDbs = _.chain(documents).pluck('databases').compact().flatten().uniq((db: any) => db.dbid).value()
      let displayDbs = []
      if (doc.in_holdings) { displayDbs = _.uniq(docDbs, (db: any) => db.url + db.name) }
      // filter out non-index databases when doc is an A&I doc
      if (doc.is_a_i) {
         displayDbs = _.chain(docDbs)
            .filter((db: any) => _.contains(db.source_types, "Index Database"))
            .uniq((db: any) => db.url + db.name).value()
      }
      return displayDbs
   }


   // Filter feed.items to retrieve only documentSummary
   getAllDocumentsSummary(items: any) {
      return items.filter((item: any) => item.type === 'documentSummary')
   }

   getTotalResults(items: any) {
      if (items.length) { return items[0].recordCount } else { return 0 }
   }
}

QuickLookService.$inject = ['configService']

angular.module('summonApp.services')
   .service('quickLookService', QuickLookService)
